<main class="container-lg px-0 py-2">
    <div *ngIf="profileUrl; else noUrl">
      <iframe [src]="profileUrl" width="100%" height="750px" title="account/profile" ></iframe>
    </div>
<!--  <div *ngIf="user">-->
<!--    <p>{{ 'ACCOUNT.INFO.LOGIN' | translate }}: {{user.login}}</p>-->
<!--    <p>{{ 'ACCOUNT.INFO.CLASS' | translate }}: {{user.userClass}}</p>-->
<!--    <p>{{ 'ACCOUNT.INFO.FNAME' | translate }}: {{user.fname}}</p>-->
<!--    <p>{{ 'ACCOUNT.INFO.LNAME' | translate }}: {{user.lname}}</p>-->
<!--    <p>{{ 'ACCOUNT.INFO.BALANCE' | translate }}: {{user.balance}}</p>-->
<!--    <p>{{ 'ACCOUNT.INFO.BDATE' | translate }}: {{user.birthDate | date}}</p>-->
<!--    <p>{{ 'ACCOUNT.INFO.ADDRESS' | translate }}: {{user.address}} {{user.address2}}, {{user.city}} {{user.postCode}}, {{user.province}} {{user.country}} </p>-->
<!--    <p>{{ 'ACCOUNT.INFO.EMAIL' | translate }}: {{user.email}}</p>-->
<!--  </div>-->
</main>

<ng-template #noUrl>
  <div class="container text-center py-5">
    <h3>{{'ACCOUNT.NOLINK_MESSAGE' | translate}}</h3>
    <h4>{{'ACCOUNT.NOLINK_TIP' | translate}}</h4>
  </div>
</ng-template>
